import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let inMemoryToken = null;
export const setToken = (t) => {
  inMemoryToken = t;
  if (t) localStorage.setItem("ehi_token", t);
  else localStorage.removeItem("ehi_token");
};

export const getToken = () => {
  if (inMemoryToken) return inMemoryToken;
  const t = localStorage.getItem("ehi_token");
  if (t) inMemoryToken = t;
  return inMemoryToken;
};

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function fmtApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
